import { cbi_invoice_type_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateCbiInvoiceTypeEnum = (enumValue: cbi_invoice_type_enum) => {
  switch (enumValue) {
    case cbi_invoice_type_enum.CANCELLATION:
      return <Trans i18nKey="Enum_CbiInvoiceTypeEnum-CANCELLATION" />;
    case cbi_invoice_type_enum.CORRECTION:
      return <Trans i18nKey="Enum_CbiInvoiceTypeEnum-CORRECTION" />;
    case cbi_invoice_type_enum.FEE_NOTICE:
      return <Trans i18nKey="Enum_CbiInvoiceTypeEnum-FEE_NOTICE" />;
    case cbi_invoice_type_enum.FEE_NOTICE_CORRECTION:
      return <Trans i18nKey="Enum_CbiInvoiceTypeEnum-FEE_NOTICE_CORRECTION" />;
    case cbi_invoice_type_enum.INVOICE:
      return <Trans i18nKey="Enum_CbiInvoiceTypeEnum-INVOICE" />;
  }
};

export const translateCbiInvoiceTypeEnum_dynamic = (enumValue: cbi_invoice_type_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case cbi_invoice_type_enum.CANCELLATION:
      return t('Enum_CbiInvoiceTypeEnum-CANCELLATION');
    case cbi_invoice_type_enum.CORRECTION:
      return t('Enum_CbiInvoiceTypeEnum-CORRECTION');
    case cbi_invoice_type_enum.FEE_NOTICE:
      return t('Enum_CbiInvoiceTypeEnum-FEE_NOTICE');
    case cbi_invoice_type_enum.FEE_NOTICE_CORRECTION:
      return t('Enum_CbiInvoiceTypeEnum-FEE_NOTICE_CORRECTION');
    case cbi_invoice_type_enum.INVOICE:
      return t('Enum_CbiInvoiceTypeEnum-INVOICE');
  }
};
